<template>
    <v-container>
        <div v-if="showcargando == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row>
            <v-card width="100%" class="mx-1">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-row>
            <v-col cols="12" md="12">
                <v-card class="text-xs-center ma-1">
                    <v-card-title class=" primary">
                        <span class="card-title-text" style="color: white;">Cambiar Contacto Inteligente</span>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <div class="container col-12 d-flex justify-content-center">
                                <v-row>
                                    <v-col cols="12" md="6">
                                        <v-container class="switch-card-style-container">
                                            <v-card class="switch-card-style rounded-xxl pt-15"
                                                    style="max-width: 300px;" :color="switchCIL1 ? 'primary' : ''">
                                                <v-card-text>
                                                    <p class="text-center  title-text-style"
                                                       :style="switchCIL1 ? 'color:#FFFFFF' : ''">
                                                        {{ linea1 }}
                                                    </p>
                                                    <div class="mb-8"></div>
                                                </v-card-text>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <div v-if="switchCIL1">
                                                        <v-card class="switch-btn-card rounded-xxl">
                                                            <v-switch class="swAjust" v-model="switchCIL1"></v-switch>
                                                        </v-card>
                                                    </div>
                                                    <div v-else>
                                                        <v-switch class="swAjust" v-model="switchCIL1"></v-switch>
                                                    </div>
                                                    <v-spacer></v-spacer>
                                                </v-card-actions>
                                            </v-card>
                                        </v-container>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-container class="switch-card-style-container">
                                            <v-card class="switch-card-style rounded-xxl pt-15"
                                                    style="max-width: 300px;" :color="switchCIL2 ? 'primary' : ''">
                                                <v-card-text>
                                                    <p class="text-center title-text-style"
                                                       :style="switchCIL2 ? 'color:#FFFFFF' : ''">
                                                        {{ linea2 }}
                                                    </p>
                                                    <div class="mb-8"></div>
                                                </v-card-text>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <div v-if="switchCIL2">
                                                        <v-card class="switch-btn-card rounded-xxl">
                                                            <v-switch class="swAjust" v-model="switchCIL2"></v-switch>
                                                        </v-card>
                                                    </div>
                                                    <div v-else>
                                                        <v-switch class="swAjust" v-model="switchCIL2"></v-switch>
                                                    </div>

                                                    <v-spacer></v-spacer>
                                                </v-card-actions>
                                            </v-card>
                                        </v-container>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-card>
                                            <v-card-title class=" primary">
                                                <span class="card-title-text" style="color: white;">
                                                    Historial de
                                                    Cambios
                                                </span>
                                            </v-card-title>
                                            <v-card-text>
                                                <DataTable :url="urlListado" :columns="columns" :params="displayInputs"
                                                           :formatterActions="formatterActions" :order="[]"
                                                           @apiDT="apiDT = $event">
                                                </DataTable>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-card>
                                            <v-card-title class=" primary">
                                                <span class="card-title-text" style="color: white;">
                                                    Usuarios y Tipo de Llamadas
                                                </span>
                                            </v-card-title>
                                            <v-card-text>
                                                <DataTable :url="urlListado2" :columns="columns2" :params="displayInputs2"
                                                           :formatterActions="formatterActions2" :order="[]"
                                                           @apiDT="apiDT = $event">
                                                </DataTable>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>

        </v-row>
        <v-dialog transition="dialog-top-transition" persistent max-width="600" v-model="modalfirma">
            <v-card>
                <v-toolbar color="primary" dark>Validar Firma</v-toolbar>
                <v-card-text>
                    <br />
                    <label> Firma electrónica: </label>
                    <br />
                    <v-text-field id="firma" ref="input" v-model="firma" autocomplete="off" maxlength="17"
                        style="-webkit-text-security: disc;" @focus="Foco()" autofocus solo></v-text-field>
                    <span v-if="errorFirma" class="mensajeerror">{{
                        messageFirma
                        }}</span>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn @click="CerrarModal(true)">Cerrar</v-btn>
                    <v-btn @click="Enviar()" color="primary" :sending="sending" :disabled="sending">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import Sistemas from "@/services/Sistemas/sistemas.service.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Menu from '@/components/pages/Sistemas/MenuSistemas.vue';

import DataTable from "@/components/pages/DataTableNet/DataTable";

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        Menu,
        DataTable
    },
    data() {
        return {
            formatterActions:[],
            permisoCambioCI: true,
            linea1: "",
            linea2: "",
            btnswitch: true,
            switchCIL1: null,
            switchCIL2: null,
            codLinea: "",
            firma: '',
            errorFirma: false,
            tel: '',
            valid: true,
            showcargando: true,
            LineaSelec: [],
            modalfirma: false,
            sending: false,
            validaTelefono: false,
            validaTelefonos: false,
            disabled: false,
            DataLineas: [],


            mostrarTabla: false,

            urlListado: "Sistemas/ListadoCambiosCI",
            columns: [
                { name: 'Linea', data: 'linea', title: "Linea" },
                { name: 'FechaCambio', data: 'fechaCambio', title: "Fecha Cambio" },
                { name: 'Usuario', data: 'uslogin', title: "Usuario" },

            ],
            datosE: {
                nrreporte: '',
                svindice: '1'
            },
            datos: {
                tipoencuesta: '',
                nrreporte: '',
                svindice: ''
            },

            displayInputs: {},

            urlListado2: "Sistemas/ListadoUsuariosTipoLlamada",
            columns2: [
                { name: 'Usuario', data: 'uslogin', title: "Usuario" },
                { name: 'tipo', data: 'tipo', title: "Tipo Llamada" },
            ],
            displayInputs2: {},
            formatterActions2: [],
        }

    },
    computed: {
        ...mapState(['permission', 'domain']),
        ...mapGetters(['getUser', 'THEME_STATE'])
    },
    methods: {

        async Enviar() {
            this.errorFirma = this.firma == '' ? true : false;
            this.messageFirma = this.firma == '' ? 'Campo requerido' : '';

            if (!this.errorFirma) {
                await this.ValidarFirma();
            }
        },

        async ValidarFirma() {

            let val = await Sistemas.valFirmaElectronica(this.firma);
            if (val == 0) {
                this.messageFirma = 'Firma electrónica incorrecta';
                this.errorFirma = true;
            } else {
                this.disabledSave = true;
                if (this.sending) { // Verifica si ya se está enviando
                    return; // Si es así, no hace nada
                }
                this.sending = true; // Establece la variable de control en true

                let Lineasinsertar;

                if (this.switchCIL1 == true) {
                    Lineasinsertar = this.DataLineas.filter(item => item.linea == 1);
                } else {
                    Lineasinsertar = this.DataLineas.filter(item => item.linea == 2);
                }

                this.$swal({
                    title: 'Guardando, espere, por favor.',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.$swal.showLoading();
                        let response = await Sistemas.InsertaCambioCI(Lineasinsertar[0].linea, Lineasinsertar[0].numero, Lineasinsertar[1].numero);
                        if (response) {
                            let mensaje = 'Se Cambio el contacto de manera exitosa.';
                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: mensaje,
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 3000
                            }).then(async () => {
                                this.CerrarModal(false)
                            });

                        } else {
                            this.disabledSave = false;
                            this.$swal({
                                position: 'center',
                                icon: 'error',
                                title: 'Error',
                                text: 'Ocurrió un error al cambiar el número de Contacto Inteligente, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.',
                                showConfirmButton: true,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                allowOutsideClick: false,
                                timer: 3000
                            })
                        }
                    }
                })
            }
            this.sending = false;
        },
        CerrarModal(updt) {
            this.modalfirma = false;
            this.firma = '';
            this.messageFirma = '';
            if (updt)
                this.switchCIL1 = !this.switchCIL1;
            else
                this.ObtieneLineaSel();
        },
        Foco() {
            this.errorFirma = false;
        },
        async ObtieneLineaSel() {
            let datos = await Sistemas.ObtenerLineasCI();
            this.DataLineas = datos;
            const lineas = [...new Set(datos.map(item => item.nombreLinea))];
            this.linea1 = lineas[0];
            this.linea2 = lineas[1];
            let DatosLinea = await Sistemas.ObtienelineaCISeleccionada();
            this.LineaSelec = DatosLinea;
            this.codLinea = datos.find(item => item.numero == DatosLinea[0].pavalor)?.linea;
            if (this.codLinea == '1') {
                this.switchCIL1 = true;
                this.switchCIL2 = !this.switchCIL1;
            } if (this.codLinea == '2') {
                this.switchCIL2 = true;
                this.switchCIL1 = !this.switchCIL2;
            }
        },

    },
    watch: {
        switchCIL1() {
            this.switchCIL2 = !this.switchCIL1;

            if ((this.codLinea != '1' && this.switchCIL1) || (this.codLinea != '2' && this.switchCIL2)) {
                this.modalfirma = true;
            }
        },
        switchCIL2() {
            this.switchCIL1 = !this.switchCIL2;

            if ((this.codLinea != '1' && this.switchCIL1) || (this.codLinea != '2' && this.switchCIL2)) {
                this.modalfirma = true;
            }
        },
        'firma'(val) {
            if (val.trim().length < 8) {
                this.messageFirma = 'Firma electrónica no cumple con las características mínimas ';
                this.errorFirma = true;
            } else {
                this.messageFirma = '';
                this.errorFirma = false;
            }
        }
    },
    async mounted() {

        this.showcargando = false;
        this.ObtieneLineaSel();

    },
    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '391').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 391)//Permiso para Sistemas cambio de contacto Inteligente
                        this.permisoCambioCI = true;
                });
            } else {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
}
</script>

<style scoped>
.text_alr {
    text-align: end;
}

.Colortext {
    color: #66BB6A !important;
}

.txpad {
    font-size: 1rem;
    padding-left: 1rem;
    margin-top: 1.3rem;
}

.swAjust {
    padding: 0;
    transform: scale(1.2);
    margin-left: 18px;
    margin-top: 10px;
}


.switch-card-style {
    min-height: 300px !important;
    min-width: 200px !important;
    max-width: 300px !important;
    margin: auto;
}

.title-text-style {
    font-family: "Poppins", sans-serif;
    font-size: 24px;
    font-weight: 800;
}

.switch-btn-card {
    width: 80px;
    height: 40px;
    background-color: #E8EAFC;
}

.switch-card-style-container {
    min-height: 300px !important;
    min-width: 200px !important;
    max-width: 300px !important;
    margin: auto;
}
</style>